import { MULTIMEDIA_TYPES, QUIZ_TYPES } from '@/constants/generalConstants';

type MultimediaType = 'series' | 'episode'; // Based on the references to MULTIMEDIA_TYPES

interface MoreData {
    seriesId?: string;
    seasonId?: string;

    [key: string]: undefined; // In case there are more dynamic keys
}

interface RouteMakerArgs {
    id: string;
    type: string;
    url: string;
    urlAlias?: string;
    multimediaType?: MultimediaType;
    moreData?: MoreData;
}

export const dynamicClientRouteMaker = ({
    id,
    type,
    url,
    urlAlias,
    multimediaType,
    moreData
}: RouteMakerArgs) => {
    // todo: read obj_types from enum, not hardcoded text
    switch (type?.toLowerCase()) {
        case 'external link': {
            /* make the link relative if it has app domain */
            const relativatedLink = url.replace(process.env.NEXT_PUBLIC_DOMAIN, '');
            return relativatedLink;
        }
        case 'video': {
            /* navigate to series page */
            if (multimediaType) {
                if (multimediaType === MULTIMEDIA_TYPES.series) {
                    return `/series/${id}`;
                }
                if (multimediaType === MULTIMEDIA_TYPES.episode) {
                    return `/series/${moreData?.seriesId ?? id}/seasons/${moreData?.seasonId ?? id}/episodes/${id}`;
                }
            }

            /* navigate to video page */
            return `/video/${id}${urlAlias ? '/' + decodeURI(urlAlias) : ''}`;
        }
        case 'audio': {
            return `/audio/${id}${urlAlias ? '/' + decodeURI(urlAlias) : ''}`;
        }
        case 'section': {
            return `/section/${id}${urlAlias ? '/' + urlAlias : ''}`;
        }
        case 'eventvideo': {
            return `/campaigns/${id}/trophy/${urlAlias ? '/' + decodeURI(urlAlias) : ''}`;
        }
        case 'campaignevent': {
            return `/campaigns/${id}`;
        }
        case 'trophy': {
            return '/you-and-dorsa-prizes';
        }
        case 'page': {
            return `/page/${id}${urlAlias ? '/' + decodeURI(urlAlias) : ''}`;
        }
        case 'fakematch': {
            return `/campaigns/${id}`;
        }
        case 'fakecampaign': {
            return `/campaigns/${id}`;
        }
        case 'raffle': {
            return '/roulette-wheel';
        }
        case 'match': {
            return `/matches/${id}`;
        }
        case 'quiz': {
            if (!moreData?.quiz_type) {
                return `/matches/${moreData?.matchId}/quiz/${id}`;
            }

            /* for simple and image quiz types, go directly to questions page */
            if ([QUIZ_TYPES.image, QUIZ_TYPES.simple].includes(moreData?.quiz_type)) {
                return `/matches/${moreData?.matchId}/quiz/${id}/questions`;
            }

            /* for other quiz types, go to quiz info page first */
            return `/matches/${moreData?.matchId}/quiz/${id}`;
        }
        case 'appmodule': {
            return '/coined-videos';
        }
        default: {
            return '';
        }
    }
};
